import React, { useMemo } from 'react';
import QuicklogHoleBar from './quicklog/QuicklogHoleBar';
import QuicklogIntervalTable from './quicklog/QuicklogIntervalTable';
import './DailyReportQuicklogPreview.css';

const DailyReportQuicklogPreview = ({
  holes = [],
  selectedHoleKey,
  onSelectHoleKey,
  quicklogByCollar = {},
  listVisualMaps = null,
  loading = false,
  error = null,
}) => {
  const activeHole = useMemo(() => {
    if (!holes.length) return null;
    if (selectedHoleKey) {
      const match = holes.find(
        (hole) => String(hole.collar_uuid || hole.hole_id) === String(selectedHoleKey)
      );
      if (match) return match;
    }
    return holes[0];
  }, [holes, selectedHoleKey]);

  const quicklogRows = useMemo(() => {
    if (!activeHole) return [];
    const key = String(activeHole.collar_uuid || activeHole.hole_id || '');
    return quicklogByCollar[key] || [];
  }, [activeHole, quicklogByCollar]);

  if (!holes.length) {
    return null;
  }

  return (
    <div className="daily-report-quicklog-preview">
      <div className="daily-report-quicklog-preview__header">
        <h3>Quicklog preview</h3>
        {holes.length > 1 ? (
          <select
            className="daily-report-quicklog-preview__select"
            value={String(activeHole?.collar_uuid || activeHole?.hole_id || '')}
            onChange={(event) => onSelectHoleKey?.(event.target.value)}
          >
            {holes.map((hole) => {
              const key = String(hole.collar_uuid || hole.hole_id || '');
              return (
                <option key={key} value={key}>
                  {hole.display_label || hole.hole_id || key}
                </option>
              );
            })}
          </select>
        ) : (
          <span className="daily-report-quicklog-preview__hole-label">
            {activeHole?.display_label || activeHole?.hole_id}
          </span>
        )}
      </div>

      {loading ? <p className="daily-report-quicklog-preview__hint">Loading quicklog...</p> : null}
      {error ? <p className="daily-report-quicklog-preview__error">{error}</p> : null}

      <div className="daily-report-quicklog-preview__panel">
        <QuicklogHoleBar
          quicklogRows={quicklogRows}
          plannedDepth={activeHole?.planned_depth}
          listVisualMaps={listVisualMaps}
          variant="screen"
        />
        <QuicklogIntervalTable
          quicklogRows={quicklogRows}
          listVisualMaps={listVisualMaps}
          variant="screen"
        />
      </div>
    </div>
  );
};

export default DailyReportQuicklogPreview;
